// Countdown Timer Script - Desarrollado por @Elkingarc_ia
// Versión simplificada y robusta

(function() {
  'use strict';
  
  console.log('CountdownTimer: Iniciando script...');

  // Evitar múltiples inicializaciones
  if (window.CountdownTimerInitialized) {
    console.log('CountdownTimer: Ya inicializado, saliendo...');
    return;
  }
  window.CountdownTimerInitialized = true;

  function CountdownTimer(element) {
    console.log('CountdownTimer: Creando nueva instancia...');
    
    // Configuración
    this.element = element;
    this.duration = parseInt(element.dataset.duration) || 900000; // 15 min default
    this.loop = element.dataset.loop === 'true';
    this.interval = null;
    
    console.log('CountdownTimer: Configuración -', {
      id: element.id,
      duration: this.duration,
      loop: this.loop,
      durationMinutes: this.duration / 60000
    });
    
    // Buscar elementos
    this.hoursEl = element.querySelector('.countdown-timer-hours');
    this.minutesEl = element.querySelector('.countdown-timer-minutes');
    this.secondsEl = element.querySelector('.countdown-timer-seconds');
    
    console.log('CountdownTimer: Elementos -', {
      hours: !!this.hoursEl,
      minutes: !!this.minutesEl,
      seconds: !!this.secondsEl
    });
    
    if (!this.hoursEl || !this.minutesEl || !this.secondsEl) {
      console.error('CountdownTimer: Elementos no encontrados');
      return;
    }
    
    // Iniciar contador
    this.start();
  }

  CountdownTimer.prototype.start = function() {
    console.log('CountdownTimer: Iniciando...');
    
    // Limpiar intervalo anterior
    if (this.interval) {
      clearInterval(this.interval);
    }
    
    const endTime = Date.now() + this.duration;
    
    const tick = () => {
      const now = Date.now();
      const remaining = endTime - now;
      
      if (remaining <= 0) {
        console.log('CountdownTimer: Terminado');
        
        if (this.loop) {
          console.log('CountdownTimer: Reiniciando...');
          this.start();
        } else {
          this.stop();
        }
        return;
      }
      
      // Calcular tiempo
      const hours = Math.floor(remaining / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
      
      // Actualizar display
      this.updateDisplay(hours, minutes, seconds);
    };
    
    // Ejecutar inmediatamente y luego cada segundo
    tick();
    this.interval = setInterval(tick, 1000);
    
    console.log('CountdownTimer: Iniciado correctamente');
  };

  CountdownTimer.prototype.updateDisplay = function(hours, minutes, seconds) {
    try {
      this.hoursEl.textContent = String(hours).padStart(2, '0');
      this.minutesEl.textContent = String(minutes).padStart(2, '0');
      this.secondsEl.textContent = String(seconds).padStart(2, '0');
    } catch (error) {
      console.error('CountdownTimer: Error actualizando display:', error);
    }
  };

  CountdownTimer.prototype.stop = function() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
      console.log('CountdownTimer: Detenido');
    }
  };

  // Función para inicializar todos los contadores
  function initCountdowns() {
    console.log('CountdownTimer: Buscando contadores...');
    
    const elements = document.querySelectorAll('[data-countdown-timer]');
    console.log('CountdownTimer: Encontrados', elements.length, 'contadores');
    
    elements.forEach(function(element, index) {
      console.log('CountdownTimer: Inicializando contador', index + 1);
      
      // Evitar doble inicialización
      if (element._countdownTimer) {
        console.log('CountdownTimer: Ya inicializado, saltando...');
        return;
      }
      
      try {
        element._countdownTimer = new CountdownTimer(element);
      } catch (error) {
        console.error('CountdownTimer: Error inicializando:', error);
      }
    });
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdowns);
  } else {
    initCountdowns();
  }

  // Manejar carga de secciones de Shopify
  document.addEventListener('shopify:section:load', function(event) {
    console.log('CountdownTimer: Sección cargada');
    
    const element = event.target.querySelector('[data-countdown-timer]');
    if (element && !element._countdownTimer) {
      console.log('CountdownTimer: Inicializando contador en nueva sección');
      try {
        element._countdownTimer = new CountdownTimer(element);
      } catch (error) {
        console.error('CountdownTimer: Error en nueva sección:', error);
      }
    }
  });

  console.log('CountdownTimer: Script cargado');
})();